import { render, staticRenderFns } from "./ReceiveDialog.vue?vue&type=template&id=d4722134"
import script from "./ReceiveDialog.vue?vue&type=script&lang=js"
export * from "./ReceiveDialog.vue?vue&type=script&lang=js"
import style0 from "./ReceiveDialog.vue?vue&type=style&index=0&id=d4722134&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports